/**
 * Header Organism Component
 * Navigation bar with logo, nav items, and CTA button
 */

import React from "react";
import { storyblokEditable } from "@/lib/blocks";
import { Container } from "@/components/atoms/Container";
import { Button } from "@/components/atoms/Button";
import { Image } from "@/components/atoms/Image";
import { NavItem } from "@/components/molecules/NavItem";
import { ProductSubNav } from "@/components/organisms/ProductSubNav";
import type { HeaderBlok } from "@/types";

export interface HeaderProps {
  blok: HeaderBlok;
}

export const Header: React.FC<HeaderProps> = ({ blok }) => {
  const { logo, nav_items, cta_button, product_sub_nav, sticky } = blok;

  return (
    <>
      <header
        {...storyblokEditable(blok)}
        className={`bg-black ${sticky ? "sticky top-0 z-50" : ""}`}
      >
        <Container className="py-5">
          <div className="flex items-center justify-between gap-8 md:gap-12">
            {/* Logo */}
            {logo && logo[0] && (
              <a
                href={
                  logo[0].home_link?.cached_url || logo[0].home_link?.url || "/"
                }
                className="flex-shrink-0"
              >
                <Image
                  src={logo[0].logo_image.filename}
                  alt={logo[0].alt_text}
                  className="h-10 w-15"
                />
              </a>
            )}

            {/* Navigation Items */}
            <nav className="hidden lg:flex items-center gap-8 xl:gap-10 flex-1 justify-center">
              {nav_items &&
                nav_items.map((item) => (
                  <NavItem
                    key={item._uid}
                    {...item}
                  />
                ))}
            </nav>

            {/* CTA Button */}
            {cta_button && cta_button[0] && (
              <div className="flex-shrink-0">
                <Button
                  href={
                    cta_button[0].button_link?.cached_url ||
                    cta_button[0].button_link?.url
                  }
                  variant={cta_button[0].button_variant || "primary"}
                  size="md"
                  className="font-bold"
                >
                  {cta_button[0].button_text}
                </Button>
              </div>
            )}
          </div>
        </Container>
      </header>

      {/* Product Sub-Navigation (outside sticky header) */}
      {product_sub_nav && product_sub_nav[0] && (
        <ProductSubNav blok={product_sub_nav[0]} />
      )}
    </>
  );
};

export default Header;
